import { LoginStatusEnum } from '@portkey/types';
export var WalletStateEnum = /*#__PURE__*/function (WalletStateEnum) {
  WalletStateEnum["Detected"] = "detected";
  WalletStateEnum["NotDetected"] = "not-detected";
  WalletStateEnum["Loadable"] = "loadable";
  return WalletStateEnum;
}({});
export var LoginStateEnum = /*#__PURE__*/function (LoginStateEnum) {
  LoginStateEnum["INITIAL"] = "INITIAL";
  LoginStateEnum["LOCK"] = "LOCK";
  LoginStateEnum["CONNECTING"] = "CONNECTING";
  LoginStateEnum["CONNECTED"] = "CONNECTED";
  LoginStateEnum["DISCONNECTING"] = "DISCONNECTING";
  return LoginStateEnum;
}({});

/**
 * getSignature
 */

export var WalletTypeEnum = /*#__PURE__*/function (WalletTypeEnum) {
  WalletTypeEnum["unknown"] = "Unknown";
  WalletTypeEnum["elf"] = "NightElf";
  WalletTypeEnum["aa"] = "PortkeyAA";
  WalletTypeEnum["discover"] = "PortkeyDiscover";
  return WalletTypeEnum;
}({});
export var SignInDesignEnum = /*#__PURE__*/function (SignInDesignEnum) {
  SignInDesignEnum["SocialDesign"] = "SocialDesign";
  SignInDesignEnum["CryptoDesign"] = "CryptoDesign";
  SignInDesignEnum["Web2Design"] = "Web2Design";
  return SignInDesignEnum;
}({});
export var NetworkEnum = /*#__PURE__*/function (NetworkEnum) {
  NetworkEnum["MAINNET"] = "MAINNET";
  NetworkEnum["TESTNET"] = "TESTNET";
  return NetworkEnum;
}({});
export var OperationTypeEnum = /*#__PURE__*/function (OperationTypeEnum) {
  OperationTypeEnum[OperationTypeEnum["unknown"] = 0] = "unknown";
  OperationTypeEnum[OperationTypeEnum["register"] = 1] = "register";
  OperationTypeEnum[OperationTypeEnum["communityRecovery"] = 2] = "communityRecovery";
  OperationTypeEnum[OperationTypeEnum["addGuardian"] = 3] = "addGuardian";
  OperationTypeEnum[OperationTypeEnum["deleteGuardian"] = 4] = "deleteGuardian";
  OperationTypeEnum[OperationTypeEnum["editGuardian"] = 5] = "editGuardian";
  OperationTypeEnum[OperationTypeEnum["removeOtherManager"] = 6] = "removeOtherManager";
  OperationTypeEnum[OperationTypeEnum["setLoginAccount"] = 7] = "setLoginAccount";
  OperationTypeEnum[OperationTypeEnum["managerApprove"] = 8] = "managerApprove";
  OperationTypeEnum[OperationTypeEnum["modifyTransferLimit"] = 9] = "modifyTransferLimit";
  OperationTypeEnum[OperationTypeEnum["transferApprove"] = 10] = "transferApprove";
  OperationTypeEnum[OperationTypeEnum["unsetLoginAccount"] = 11] = "unsetLoginAccount";
  OperationTypeEnum[OperationTypeEnum["setupBackupMailbox"] = 13] = "setupBackupMailbox";
  return OperationTypeEnum;
}({});
export { LoginStatusEnum };